/**
 * Clear Banner Alert Action - WHAT Section
 *
 * Clears all active banner alerts for matched clients.
 * No specific alert selection needed.
 *
 * V2 Reference: v2/app/templates/components/client-reminder-clear-banner-alert.hbs
 */

import { FC } from 'react';

import { ActionWhatSectionProps } from '../automationActions';

export const ClearBannerAlertWhatSection: FC<ActionWhatSectionProps> = () => {
  return null;
};

export const ClearBannerAlertWhatSummary: FC<{
  automation: ActionWhatSectionProps['automation'];
}> = () => {
  return null;
};
